// Labels and formatting shared by every support screen (list panel, ticket page, Support button, /support).

export const TYPE_LABELS     = { issue: 'Issue', question: 'Question', feedback: 'Feedback' };
export const STATUS_LABELS   = { open: 'Open', in_progress: 'In Progress', resolved: 'Resolved', closed: 'Closed' };
export const PRIORITY_LABELS = { low: 'Low', medium: 'Medium', high: 'High' };
export const STATUS_CLASSES  = { open: 'badge-open', in_progress: 'badge-in-progress', resolved: 'badge-resolved', closed: 'badge-closed' };
export const OPEN_STATUSES   = new Set(['open', 'in_progress']);

// The status a customer reads: the support team's own wording when there is one (the ticket's status_label), else hub's.
export const statusText = (t) => t.status_label || STATUS_LABELS[t.status] || t.status;

export const formatDate = (ts) => (ts
    ? new Date(ts).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : '—');

// THE PRODUCT A TICKET IS ABOUT — the product, the instance's name and its id (support.js withProductNames), and the
// screen it lives on, so the ticket links back to what it was raised from.
export const PRODUCT_LABELS = {
    Sync: 'Sync', Toolkit: 'Migration Toolkit', Vault: 'Vault', PaymentPorter: 'Payment Porter',
    OperaCloudCompare: 'Opera Cloud Compare', Dryft: 'Dryft', DvmExtractor: 'DVM Extractor', Pipelines: 'Pipelines',
    MCP: 'MCP as a Service', Hub: 'Hub',
};
export const ticketProduct = (t) => {
    if (!t.product) return null;
    const label = PRODUCT_LABELS[t.product] || t.product;
    if (!t.product_id) return label;
    return `${label} › ${t.product_name || 'Unnamed'} (#${t.product_id})`;
};
const PRODUCT_PATHS = {
    Sync: (t) => `/sync/${t.product_id}`,
    Toolkit: (t) => `/sync/${t.product_id}/toolkit`,
    Vault: (t) => `/vaults/${t.product_id}`,
    PaymentPorter: (t) => `/apps/payment-porter/${t.product_id}`,
    OperaCloudCompare: (t) => `/apps/opera-cloud-compare/${t.product_id}`,
    Dryft: (t) => `/apps/dryft/${t.product_id}`,
    DvmExtractor: (t) => `/apps/dvm-extractor/${t.product_id}`,
    Pipelines: (t) => (t.product_ref ? `/pipelines/${t.product_ref}/implementations/${t.product_id}` : null),
    MCP: (t) => `/mcp-service/hotels/${t.product_id}`,
};
/** The screen of the instance a ticket is about, or null (no instance, or one whose name was not found). */
export const ticketProductPath = (t) => (t.product_id && t.product_name && PRODUCT_PATHS[t.product]
    ? PRODUCT_PATHS[t.product](t) : null);

export const ticketContext = (t) => {
    const parts = [t.partner_name, t.account_name, t.hotel_name].filter(Boolean);
    if (!t.hotel_name && t.account_id) parts.push('All hotels');
    return parts.join(' › ') || '—';
};
